import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { GenericModalModule } from '../modal/generic-modal.module';
import { LoadingCirclesComponent } from './loading-circles.component';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        GenericModalModule
    ],
    declarations: [
        LoadingCirclesComponent
    ],
    exports: [
        LoadingCirclesComponent
    ]
})

export class LoginCirclesModule {
}
